module.exports = __webpack_public_path__ + "static/img/ListWinnersBg.8350ba6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/ListWinnersBg.png
// module id = A4Dq
// module chunks = 0